// @flow
import type { CallFn } from 'redux-saga/effects';
import { call, put, spawn } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import { setupSagaTarget } from '@wh/saga-utils';
import { publish } from '@wh/message-bus';
import { constants } from '@wh/login-component';
import { actions } from '@wh/modal-component';

import {
    MESSAGE_PUB_USER_LOGGED_IN,
    MESSAGE_PUB_DISPLAY_REGISTRATION_FORM,
    MODAL_ACCOUNT_RECOVERY,
} from './constants';

/**
 * Process userLoggedIn
 * @param {Object} action Action of type constants.USER_LOGGED_IN
 * @returns {Iterator} Iterator
 */
export function* userLoggedInHandler(action: Object): Iterator<*> {
    yield call(publish, MESSAGE_PUB_USER_LOGGED_IN, action.casData);
    yield put(actions.closeModal());
}

/**
 * Process registration
 * @returns {Iterator} Iterator
 */
export function* registrationHandler(): Iterator<*> {
    yield call(publish, MESSAGE_PUB_DISPLAY_REGISTRATION_FORM, {});
    yield put(actions.closeModal());
}

/**
 * Process account recovery
 * @returns {Iterator} Iterator
 */
export function* accountRecoveryHandler(): Iterator<*> {
    yield put(actions.openModal(MODAL_ACCOUNT_RECOVERY));
}

/**
 * Watch sagas
 * @returns {void}
 */
function* watchSagasModal(): Iterator<CallFn> {
    yield spawn(takeLatest, constants.USER_LOGGED_IN, userLoggedInHandler);
    yield spawn(takeLatest, constants.REGISTRATION_CLICKED, registrationHandler);
    yield spawn(takeLatest, constants.ACCOUNT_RECOVERY_CLICKED, accountRecoveryHandler);
}

export default setupSagaTarget(watchSagasModal, true, true);



// WEBPACK FOOTER //
// ./src/main/sagas.js